import { createFileRoute } from "@tanstack/react-router";
import { EkycCallbackPage } from "@/features/ekyc/EkycCallbackPage";

export const Route = createFileRoute("/ekyc/success/$clientId")({
  component: EkycSuccessComponent,
});

function EkycSuccessComponent() {
  const { clientId } = Route.useParams();
  return <EkycCallbackPage clientId={Number(clientId)} type="success" />;
}
